import {Icon} from '../Icon';
import {Button} from '../shadcn/button';

import type {IconName} from '../Icon';
import type {ComponentPropsWithoutRef} from 'react';

export interface IconButtonProps extends Omit<ComponentPropsWithoutRef<'button'>, 'children'> {
  icon: IconName;
  isLoading?: boolean;
}

export const IconButton = ({icon, className, ...props}: IconButtonProps) => {
  return (
    <Button
      variant="secondary"
      size="icon-sm"
      icon={<Icon name={icon} width={18} height={18} strokeWidth={1.8} />}
      className={className}
      {...props}
    />
  );
};
